import { createContext, useContext, type ReactNode } from 'react';

import { useNetworkQuestions } from './hooks/useNetworkQuestions';
import type { CuratedAccountPlanQuestion } from './types';

interface NetworkQuestionsContextValue {
  questions: CuratedAccountPlanQuestion[];
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
  submitAnswer: (questionId: number, answer: string) => Promise<boolean>;
}

const NetworkQuestionsContext = createContext<NetworkQuestionsContextValue | undefined>(undefined);

export function NetworkQuestionsProvider({ children }: { children: ReactNode }): React.ReactElement {
  const value = useNetworkQuestions();
  return (
    <NetworkQuestionsContext.Provider value={value}>
      {children}
    </NetworkQuestionsContext.Provider>
  );
}

export function useNetworkQuestionsContext(): NetworkQuestionsContextValue {
  const ctx = useContext(NetworkQuestionsContext);
  if (!ctx) {
    throw new Error('useNetworkQuestionsContext must be used within NetworkQuestionsProvider');
  }
  return ctx;
}
